// extracted by mini-css-extract-plugin
export default {"block":"PostPayment_block__NX6fI","tooltip":"PostPayment_tooltip__0Chad","tooltip_content":"PostPayment_tooltip_content__+IJyR"};